export enum UserTypeEnum {
  Individual = 1,
  Organization = 2,
  Mixed = 3,
  Admin = 4,
  System = 5
};
